export interface SearchResult {
  name: string
  [key: string]: any
}

export interface SearchParams {
  country: string
  data_source: string
  date_of_birth: string
  entity_type: string
  min_score: number
  name: string
}

export type Status =
  | 'queued'
  | 'cleared'
  | 'pending_review'
  | 'false_positive'
  | 'confirmed_match'
  | 'error'
  | 'error_search_retries_count_exceeded'

export interface Check {
  id: number
  group_id: number
  subject_id: number
  subject_type: string
  note: string
  raw_search_response: {
    error?: string
    count: number
    results: SearchResult[]
    search: {
      params: SearchParams
    }
  }
  reviewed_at: string
  reviewed_by: {
    id: number
    name: string
  }
  status: Status
}

interface AccreditationOption {
  id: string
  option: string
  status: AccreditationStatus
}

interface AccreditationTemplateSection {
  title: string
  options: AccreditationOption[]
}

export enum AccreditationStatuses {
  NotAccredited = 'non_accredited',
  Accredited = 'accredited',
  QualifiedPurchaser = 'qualified_purchaser',
}

export interface Accreditation {
  id: string
  completed_at: string
  completed_by_id: number
  expired_at: string
  response_id: number
  status: AccreditationStatus
  template: AccreditationTemplateSection[]
  year: number
}

export type AccreditationStatus = AccreditationStatuses[keyof AccreditationStatuses]
